module.exports = __webpack_public_path__ + "static/media/logo-inv.5e49d80d.svg";